var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopiedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 8.33335C6.66602 7.89133 6.84161 7.4674 7.15417 7.15484C7.46673 6.84228 7.89065 6.66669 8.33268 6.66669H14.9993C15.4414 6.66669 15.8653 6.84228 16.1779 7.15484C16.4904 7.4674 16.666 7.89133 16.666 8.33335V15C16.666 15.442 16.4904 15.866 16.1779 16.1785C15.8653 16.4911 15.4414 16.6667 14.9993 16.6667H8.33268C7.89065 16.6667 7.46673 16.4911 7.15417 16.1785C6.84161 15.866 6.66602 15.442 6.66602 15V8.33335Z",
    stroke: "#7B51F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 6.66668V5.00001C13.334 4.55798 13.1584 4.13406 12.8458 3.8215C12.5333 3.50894 12.1093 3.33334 11.6673 3.33334H5.00065C4.55862 3.33334 4.1347 3.50894 3.82214 3.8215C3.50958 4.13406 3.33398 4.55798 3.33398 5.00001V11.6667C3.33398 12.1087 3.50958 12.5326 3.82214 12.8452C4.1347 13.1577 4.55862 13.3333 5.00065 13.3333H6.66732",
    stroke: "#7B51F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopiedIcon);
export default __webpack_public_path__ + "static/media/copied-icon.5cc60696f59a6431b24a082a6c967486.svg";
export { ForwardRef as ReactComponent };